import { render, staticRenderFns } from "./PopupAddCategory.vue?vue&type=template&id=a06c5a88&"
import script from "./PopupAddCategory.vue?vue&type=script&lang=js&"
export * from "./PopupAddCategory.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddCategory.vue?vue&type=style&index=0&id=a06c5a88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports